<template>
  <div>
    <v-layout justify-space-between align-center class="to-hide">
      <v-flex v-if="$route.query.preview" xs6>
        <div class="mb-12">
          <div class="page-title mb-2">แบบฟอร์มคำร้องขอใช้พื้นที่</div>
        </div>
      </v-flex>
      <v-flex xs6>
        <v-layout justify-end mb-4>
          <v-flex shrink mr-4> </v-flex>
          <v-flex shrink mr-4>
            <v-btn color="#e51610" outlined rounded depressed @click.native="print()" v-if="$route.query.preview">
              <Iconify style="color: #e51610" icon="fluent:document-pdf-24-filled"></Iconify>
              <span style="color: #e51610">Export PDF </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="d-flex flex-column gap-12 mb-6" id="pdf">
      <div class="d-flex flex-column align-center to-show"
        style="gap: 14px; display: none; visibility: hidden; height: 0px">
        <div class="d-flex align-center">
          <v-img :src="require('@/assets/Logo2.png')" width="146" height="48" aspect-ratio="1"></v-img>
        </div>

        <div class="d-flex align-center">
          <div class="page-title">แบบฟอร์มคำร้องขอใช้พื้นที่</div>
        </div>
        <div class="d-flex align-center">
          <div class="txt-head">
            โดยอุทยานวิทยาศาสตร์ {{ form.region ?? "" }}
          </div>
        </div>
      </div>
      <divcard titled>
        <div class="txt-head black--text mb-2 d-flex align-items-center card-part-orange">
          <span class="theme-color-one">ส่วนที่ 1 : </span>
          ข้อมูลประเภทพื้นที่
        </div>
        <div>
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('one')"></ValidatorIcon>
            1. ข้อมูลประเภทผู้ใช้บริการพื้นที่ (User Type)
            เลือกตอบเพียงประเภทเดียว
          </div>
          <div class="mx-5 card-part">
            {{ form?.user_type?.name }}
          </div>
        </div>
      </divcard>
      <divcard titled>
        <div class="txt-head black--text mb-2 d-flex align-items-center card-part-orange">
          <span class="theme-color-one">ส่วนที่ 2 : </span>
          ข้อมูลบริษัท/หน่วยงาน
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_one')"></ValidatorIcon>
            1. ข้อมูลบริษัท/หน่วยงาน
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ชื่อบริษัท (ภาษาไทย) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.company_name_th }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ชื่อบริษัท (ภาษาอังกฤษ) </v-col><v-col
                  class="py-0" cols="6">{{
                    form?.area_form_2?.company_name_eng
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ที่อยู่ </v-col><v-col class="py-0"
                  cols="6">
                  {{ form?.area_form_2?.headquarters_address }}
                </v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> รหัสไปรษณีย์ (Postal) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.headquarters_postal_code }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> โทรศัพท์ (Telephone No.) </v-col><v-col
                  class="py-0" cols="6">{{
                    form?.area_form_2?.headquarters_phone
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> โทรสาร (Facsimile No.) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.headquarters_fac }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> อีเมล (E-mail) </v-col><v-col
                  class="py-0" cols="6">{{
                    form?.area_form_2?.headquarters_email
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> เว็บไซต์ (Website) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.headquarters_website }}
                </v-col></v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_two')"></ValidatorIcon>
            2. ข้อมูลผู้ติดต่อประสานงาน (Contact Person)
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ชื่อ-สกุล (Name) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.contact_name }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ตำแหน่ง (Position) </v-col><v-col
                  class="py-0" cols="6">{{
                    form?.area_form_2?.contact_position
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> โทรสาร (Facsimile No.) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.contact_fac }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> อีเมล (E-mail) </v-col><v-col
                  class="py-0" cols="6">{{
                    form?.area_form_2?.contact_email
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> โทรศัพท์ (Telephone No.) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.contact_phone }}
                </v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ที่อยู่ </v-col><v-col class="py-0"
                  cols="6">
                  {{ form?.area_form_2?.contact_address }}
                </v-col></v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_three')"></ValidatorIcon>
            3. ข้อมูลการจดทะเบียนบริษัท (Company Registration Information)
          </div>
          <div class="mb-1 black--text mt-3 mx-10">
            3.1 ข้อมูลผู้ประสานงานโครงการ
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  ทะเบียนเลขที่ (Company Registration Number)
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  วันที่จดทะเบียน (Company Registration Date)
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  {{ form?.area_form_2?.registration_number }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  {{ form?.area_form_2?.registration_date }}
                </v-col></v-col>
            </v-row>
          </div>
          <div class="mb-1 black--text mt-3 mx-10">
            3.2 ทุนจดทะเบียน (Registered Capital)
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  ทุนจดทะเบียน (Registered Capital)
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  {{
                    Number(
                      form?.area_form_2?.registration_capital || 0
                    ).toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
                  }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
            </v-row>
          </div>
          <div class="mb-1 black--text mt-3 mx-10">3.3 ขนาดของธุรกิจ</div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  {{ form?.area_form_2?.business_size?.name }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
            </v-row>
          </div>
          <div class="mb-1 black--text mt-3 mx-10">
            3.4 กรรมการผู้มีอำนาจลงนามของบริษัท (Authorized person of company)
          </div>
          <div class="mx-10">
            <div v-for="(item, index) in form?.area_form_2?.area_form_2_3" :key="index" class="mx-10 card-part" :class="index + 1 == form?.area_form_2?.area_form_2_3?.length
              ? 'px-6'
              : ''
              ">
              <div class="mx-5">
                {{ "3.4." + (index + 1) + " บุคคลที่ " + (index + 1) }}
                <v-row class="pt-6">
                  <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ชื่อ-สกุล (Name) </v-col><v-col
                      class="py-0" cols="6">
                      {{ item.name }}
                    </v-col></v-col>
                  <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ตำแหน่ง (Position) </v-col><v-col
                      class="py-0" cols="6">{{
                        item.position
                      }}</v-col></v-col>
                </v-row>
                <v-row class="pt-2">
                  <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                      โทรศัพท์ (TelePhone No.) </v-col><v-col class="py-0" cols="6">
                      {{ item.phone }}
                    </v-col></v-col>
                  <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> อีเมล (E-mail) </v-col><v-col
                      class="py-0" cols="6">{{
                        item.email
                      }}</v-col></v-col>
                </v-row>
                <v-row class="pt-2">
                  <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> มือถือ (Mobile Phone) </v-col><v-col
                      class="py-0" cols="6">
                      {{ item.mobile_phone }}
                    </v-col></v-col>
                </v-row>
              </div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <!-- <ValidatorIcon
              v-if="!$route.query.preview"
              :is-correct="validate('two_four')"
            ></ValidatorIcon> -->
            4. ข้อมูลเกี่ยวกับบริษัทแม่/บริษัทร่วมทุน (ถ้ามี) (Headquarter/Joint
            Venture Company Information (If any))
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ชื่อบริษัท (Company Name) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.headquarters_joint_name }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> สัญชาติ (Nationality) </v-col><v-col
                  class="py-0" cols="6">{{
                    form?.area_form_2?.headquarters_joint_nationality
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                  ประเทศที่ตั้ง (Located Country) </v-col><v-col class="py-0" cols="6">
                  {{ form?.area_form_2?.headquarters_joint_country }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                  ทุนจดทะเบียน (Registered Capital) </v-col><v-col class="py-0" cols="6">{{
                    (form?.area_form_2?.headquarters_joint_capital == null || form?.area_form_2?.headquarters_joint_capital === "")
                      ? "-"
                      : Number(form?.area_form_2?.headquarters_joint_capital).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                  }}</v-col></v-col>
            </v-row>
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> เว็บไซต์ (Website) </v-col><v-col
                  class="py-0" cols="6">
                  {{ form?.area_form_2?.headquarters_joint_website }}
                </v-col></v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_five')"></ValidatorIcon>
            5. ประเภทอุตสาหกรรม (Industry Category)
          </div>
          <div v-for="(item, index) in form?.form2_5" :key="index" class="mx-10 pt-2">
            {{ changeToFullName(item.name) }}
            {{
              changeToFullName(item.name) == "Other"
                ? " - " + form?.area_form_2?.industry_others_specify
                : ""
            }}
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_six')"></ValidatorIcon>
            6. เหตุผลในการเลือกอยู่อาคารอำนวยการอุทยานวิทยาศาสตร์
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="12"><v-col class="py-0" cols="12">
                  เหตุผลในการเลือกอยู่อาคารอำนวจการอุทยานวิทยาศาสตร์
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="12"></v-col>
              <v-col class="py-0 d-flex" cols="12"><v-col class="py-0 text-break" cols="12">
                  {{ form?.area_form_2?.reason_choose }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="12"></v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_seven')"></ValidatorIcon>7.
            ประเภทผู้ใช้บริการพื้นที่
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  ประเภทผู้ใช้บริการพื้นที่
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  {{ form?.area_form_2?.area_type?.name }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_eight')"></ValidatorIcon>
            8. ภูมิภาค (Region)
          </div>
          <div class="mx-10 card-part">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12"> ภูมิภาค </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
              <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="12">
                  {{ form?.area_form_2?.region }}
                </v-col></v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_nine')"></ValidatorIcon>
            9. ลำดับความต้องการของตำแหน่งห้อง (Prioritize your favorite room)
          </div>
          <!-- area_form_2_8 เดิมเป็นข้อ 8 ย้ายมาเป็นข้อ 9 แล้ว -->
          <div v-for="(i, index) in form?.area_form_2?.area_form_2_8" :key="index" class="pt-6 mx-15">
            <div>
              <div> {{
                "9." +
                (index + 1) +
                " ลำดับ " +
                (index + 1) +
                " (" +
                (index + 1) +
                (index + 1 === 1
                  ? "st"
                  : index + 1 === 2
                    ? "nd"
                    : index + 1 === 3
                      ? "rd"
                      : "th") +
                " Priority)"
                }}</div>
              <div class="mb-1 black--text">ประเภทห้องที่ต้องการ</div>
              <div>{{ i.room_type ?? '-' }}</div>
              <div class="mb-1 black--text">ขนาดห้อง ตร.ม</div>
              <div>
                {{ i.room_size ?? '-' }}
              </div>
            </div>
            <!-- <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6">
                 
                </v-col></v-col
              >
              <v-col class="py-0 d-flex" cols="6"></v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-col class="py-0" cols="6">{{ '1'}}</v-col>
              </v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
              <v-col class="py-0 d-flex" cols="6"
                ><v-col class="py-0" cols="6">
                  {{
                    'ขนาดห้อง ตร.ม'
                  }}
                </v-col></v-col
              >
              <v-col class="py-0 d-flex" cols="6"></v-col>
              <v-col class="py-0 d-flex" cols="6">
                <v-col class="py-0" cols="6">{{ i?.room_size }}</v-col>
              </v-col>
              <v-col class="py-0 d-flex" cols="6"></v-col>
            </v-row> -->
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_ten')"></ValidatorIcon>
            10. ความต้องการใช้พื้นที่อาคาร (Space Requirement)
          </div>
          <div class="mx-10 pt-6">
            <v-row class="pt-2">
              <v-col class="py-0 d-flex" cols="12">
                <v-col class="py-0" cols="12">ประเภทการใช้พื้นที่ (Type of Space Requirement)</v-col>
              </v-col>
              <v-col class="py-0 d-flex" cols="12"></v-col>
              <v-col class="py-0 d-flex" cols="12">
                <v-col class="py-0" cols="12">
                  <div>
                    {{ form?.area_form_2?.space_requirement_type }}
                  </div>
                  <div v-if="
                    form?.area_form_2?.space_requirement_type ==
                    'สำนักงานเพื่อการจัดตั้งธุรกิจนวัตกรรม (Startup)'
                  ">
                    {{ form?.area_form_2?.space_requirement_startup }}
                  </div>
                </v-col>
              </v-col>
              <v-col class="py-0 d-flex" cols="12"></v-col>
            </v-row>
          </div>
          <div class="mx-10 py-5" v-for="(item, i) in form?.area_form_2?.area_form_2_9" :key="i">
            <div>{{ "10." + (i + 1) + " บุคคลที่ " + (i + 1) }}</div>
            <div class="mx-5">
              <v-row class="pt-2">
                <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                    บุคคลที่ {{ i + 1 }} ทำหน้าที่
                  </v-col></v-col>
                <v-col class="py-0 d-flex" cols="6"></v-col>
                <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                    {{ item.position }}
                  </v-col></v-col>
                <v-col class="py-0 d-flex" cols="6"></v-col>
              </v-row>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_eleven')"></ValidatorIcon>
            11. การสนับสนุนหรือให้บริการแก่ผู้ใช้งานอาคารฯ รายอื่นๆ (Products or
            Service to Contribute for Regional Science Park)
          </div>
          <div class="mx-10 card-part">
            การสนับสนุนหรือให้บริการแก่ผู้ใช้งานอาคารฯ รายอื่นๆ (Products or
            Service to Contribute for Regional Science Park)
            <div class="text-break">
              {{ form?.area_form_2?.product_service_eco }}
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_twelve')"></ValidatorIcon>
            12. สัดส่วนการบริหารจัดการพื้นที่ต่อพื้นที่ทั้งหมด 100% (Space
            Utilization Ratio)
          </div>
          <div class="mx-10 card-part">
            <div v-if="form?.area_form_2?.space_ratio_lab">
              อัตราการใช้พื้นที่สำหรับเป็นห้องปฏิบัติการ หรือหน่วยงานวิจัยพัฒนา
              <div>{{ form?.area_form_2?.space_ratio_lab_percent }}</div>
            </div>
            <div v-if="form?.area_form_2?.space_ratio_office">
              อัตราการใช้พื้นที่สำหรับเป็นสำนักงาน (Office) เปอร์เซ็นต์
              <div>{{ form?.area_form_2?.space_ratio_office_percent }}</div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('two_thirteen')"></ValidatorIcon>
            13. การบริหารงานของบริษัท / หน่วยงาน
            ภายในพื้นที่อาคารอำนวยการอุทยานวิทยาศาสตร์ (Type of area usage)
          </div>
          <div class="mx-10 card-part">
            <div>{{ form?.area_form_2?.type_of_area_usage }}</div>
            <div v-if="
              form?.area_form_2?.type_of_area_usage ===
              'จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)'
            ">
              {{
                form?.area_form_2?.type_of_area_usage_th +
                " / " +
                form?.area_form_2?.type_of_area_usage_eng
              }}
            </div>
            <div v-if="form?.area_form_2?.type_of_area_usage === 'อื่นๆ'">
              {{ form?.area_form_2?.type_of_area_usage_other }}
            </div>
          </div>
        </div>
      </divcard>
      <divcard titled>
        <div class="txt-head black--text mb-2 d-flex align-items-center card-part-orange">
          <span class="theme-color-one">ส่วนที่ 3 : </span>
          แผนงาน
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('three_one')"></ValidatorIcon>
            1. แผนงานการทำงานวิจัยและพัฒนา งานออกแบบ
            และงานวิศวกรรมภายในอาคารอำนวยการ
          </div>
          <div>
            <div class="d-flex justify-space-between card-part pt-6 mx-5">
              <div v-for="(item, i) in tableHeader" :key="i" :style="{ width: item.width }" class="txt-bigger">
                {{ item.name }}
              </div>
            </div>
            <div class="card-part mx-5">
              <div v-if="form.area_form_3?.spider_chart_3 && form.area_form_3?.spider_chart_3.length > 0"
                class="d-flex flex-column gap-12">
                <div v-for="(item, i) in form.area_form_3?.spider_chart_3" :key="i" class="d-flex mb-3">
                  <div class="flex text-break" style="min-width: 10%; max-width: 10%">
                    {{ item.year }}
                  </div>
                  <div class="flex text-break" style="min-width: 20%; max-width: 20%">
                    {{ item.name }}
                  </div>
                  <div class="flex text-break" style="min-width: 30%; max-width: 30%">
                    {{ item.plan }}
                  </div>
                  <div class="flex text-break" style="min-width: 15%; max-width: 15%">
                    {{
                      Number(item.budget || 0).toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) + " บาท"
                    }}
                  </div>
                  <div class="flex" style="min-width: 15%; max-width: 15%">
                    <!-- {{ toDateFormat2(item.duration_from) }} ถึง
                  {{ toDateFormat2(item.duration_to) }} -->
                    {{ item.duration }}
                  </div>
                  <div class="flex text-break" style="min-width: 10%; max-width: 10%">
                    {{
                      item?.source_topical.join(", ") +
                      (item?.source_topical_other
                        ? "(" + item?.source_topical_other + ")"
                        : "")
                    }}
                  </div>
                </div>
              </div>
              <div v-else class="no-plan-item">ไม่มีข้อมูล</div>
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('three_two')"></ValidatorIcon>
            2. แผนอัตรากำลังคนที่ปฏิบัติงานเฉพาะในอาคารอำนวยการอุทยานวิทยาศาสตร์
          </div>
          <div class="pt-6">
            <v-row class="pt-2 txt-bigger">
              <v-col class="py-0 d-flex">
                <v-col class="py-0">
                  <div>ระดับวุฒิการศึกษา</div>
                  <div>(Education Level)</div>
                </v-col>
                <v-col class="py-0">
                  <div>ปีที่ 1</div>
                  <div>(จำนวนที่เพิ่มขึ้นในปี)</div>
                </v-col>
                <v-col class="py-0">
                  <div>ปีที่ 2</div>
                  <div>(จำนวนที่เพิ่มขึ้นในปี)</div>
                </v-col>
                <v-col class="py-0">
                  <div>ปีที่ 3</div>
                  <div>(จำนวนที่เพิ่มขึ้นในปี)</div>
                </v-col>
                <v-col class="py-0">
                  <div>รวมพนักงานทั้งหมด</div>
                </v-col>
              </v-col>
            </v-row>
            <v-row v-for="(item, i) in form?.area_form_3?.area_form_3_2" :key="i" class="pt-2">
              <v-col class="py-0 d-flex">
                <v-col class="py-0">{{ item?.education_level }}</v-col>
                <v-col class="py-0">
                  {{ item?.year_1 }}
                </v-col>
                <v-col class="py-0">
                  {{ item?.year_2 }}
                </v-col>
                <v-col class="py-0">
                  {{ item?.year_3 }}
                </v-col>
                <v-col class="py-0">
                  {{ item?.total_employee }}
                </v-col>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('three_three')"></ValidatorIcon>
            3. ประมาณการวันที่ต้องการใช้พื้นที่ (หากได้รับอนุมัติ) (Contract
            start date (if approved))
          </div>
          <div class="card-part mx-10">
            <div>วัน เดือน ปี</div>
            <div class="mx-5">
              {{ form?.area_form_3?.estimated_date }}
            </div>
          </div>
        </div>
        <div class="card-part">
          <div class="txt-head black--text mb-2 d-flex gap-8">
            <ValidatorIcon v-if="!$route.query.preview" :is-correct="validate('three_four')"></ValidatorIcon>
            4. เอกสารแนบ / ภาคผนวก Annex / Appendix
          </div>
          <div class="mx-3">
            <div>
              1. สำเนาเอกสารสำคัญประกอบการสมัคร (The application shall be
              accompanied with the following documents)
              (กรุณาประทับตราบริษัทและลงนาม รับรองโดยผู้มีอำนาจของบริษัท Please
              sign by company authorized person and stamp the company seal)
              <div class="mx-2">
                <div>
                  1.1 หนังสือรับรองบริษัทที่มีอายุไม่เกิน 30 วัน Certificate of
                  company registration, not more than 30 days issues
                </div>
                <div>1.2 ภพ. 20 (Vat certificate (Phor por 20))</div>
                <div>1.3 หนังสือบริคณห์สนธิ (Memorandum of Association)</div>
                <div>
                  1.4 งบการปีล่าสุดย้อนหลัง 2 ปี (Financial Statement for recent
                  calendar year with Cerified Public Accountant CPA’s approval)
                </div>
                <div>
                  1.5 กรณีเป็นบริษัทตั้งใหม่ กรุณาแสดงหลักฐานทางการเงินของบริษัท
                  (In case of newly established company, please attach a copy of
                  company Bank Statement)
                </div>
                <div>
                  1.6 เอกสารรายละเอียดเพิ่มเติม (ถ้ามี) Other related documents
                  (If applicable)
                </div>
              </div>
              <div class="mt-5">
                2.
                ข้อมูลประกอบเพื่อการคัดเลือกและประเมินผู้ใช้พื้นที่อาคารอำนวยการอุทยานวิทยาศาสตร์
                (Information for evalution process (2 main criteria's will be
                considered during this step, (1) space usage activities, (2)
                Financial data))
                <div class="mx-2">
                  <div v-if="form?.area_form_3?.appendix_info">
                    2.1 กรุณาเสนอวันที่นัดหมายสำหรับบริษัท / หน่วยงาน
                    เข้านำเสนอข้อมูลต่อผู้เชี่ยวชาญ
                  </div>
                  <div v-else>-</div>
                </div>
              </div>
              <div class="mt-5">
                3. สำเนาเอกสารประกอบการทำสัญญาการให้บริการอุทยานวิทยาศาสตร์
                (Documentation for contract) (กรุณาประทับตราบริษัทและ
                ลงนามรับรองโดยผู้มีอำนาจของบริษัท Please sign by company
                authorized person and stamp the company seal)
                <div class="mx-2">
                  <div v-if="form?.area_form_3?.appendix_doc_cert">
                    3.1 หนังสือรับรองบริษัทที่มีอายุไม่เกิน 30 วัน Certificate
                    of company registration, not more than 30 days issued
                  </div>
                  <div v-if="form?.area_form_3?.appendix_doc_id_card_company">
                    3.2
                    สำเนาบัตรประชาชนผู้มีอำนาจลงนามจำนวนตามที่ระบุไว้ในหนังสือรับรอง
                    Copy of ID card/passport of authorizedperson(s) as specified
                    in company certificate.
                  </div>
                  <div v-if="form?.area_form_3?.appendix_doc_witness">
                    3.3 สำเนาบัตรประชาชนพยานฝ่ายบริษัท จำนวน 1 คน (Copy of ID
                    card/passport (one person) for the witness)
                  </div>
                  <div v-if="form?.area_form_3?.appendix_doc_postal">
                    3.4 ชื่อผู้รับ
                    และที่อยู่สำหรับการจัดส่งสัญญาผ่านทางไปรษณีย์ลงทะเบียนให้บริษัท
                    (The receipt's name and address for the contract receiving
                    via registered mail) (กรุณาแนบนามบัตร (ถ้ามี) Please attach
                    a business card (if applicable))
                  </div>
                  <div v-if="form?.area_form_3?.appendix_doc_postal" class="pt-2 mb-4">
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          ชื่อ - สกุล (Name) </v-col><v-col class="py-0" cols="6">
                          {{ form?.area_form_3?.postal_name }}
                        </v-col></v-col>
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          ตำแหน่ง (Position) </v-col><v-col class="py-0" cols="6">{{
                            form?.area_form_3?.postal_position
                          }}</v-col></v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          โทรศัพท์ (Telephone No.) </v-col><v-col class="py-0" cols="6">
                          {{ form?.area_form_3?.postal_phone }}
                        </v-col></v-col>
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          มือถือ (Mobile Phone) </v-col><v-col class="py-0" cols="6">{{
                            form?.area_form_3?.postal_mobile_phone
                          }}</v-col></v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          โทรสาร (Facsimile No.) </v-col><v-col class="py-0" cols="6">
                          {{ form?.area_form_3?.postal_fac }}
                        </v-col></v-col>
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> อีเมล (E-mail) </v-col><v-col
                          class="py-0" cols="6">{{
                            form?.area_form_3?.postal_email
                          }}</v-col></v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ที่อยู่ </v-col><v-col
                          class="py-0" cols="6">
                          {{ form?.area_form_3?.postal_address }}
                        </v-col></v-col>
                    </v-row>
                  </div>
                  <div v-if="form?.area_form_3?.appendix_doc_contact">
                    3.5 ข้อมูลรายชื่อสำหรับการติดต่อในระหว่างการใช้บริการพื้นที่
                    (Contact person for : (กรุณาแนบนามบัตร (ถ้ามี) Please attach
                    a business card (if applicable)))
                  </div>
                  <div v-if="form?.area_form_3?.appendix_doc_contact" class="pt-2">
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          ชื่อ - สกุล (Name) </v-col><v-col class="py-0" cols="6">
                          {{ form?.area_form_3?.contact_name }}
                        </v-col></v-col>
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          ตำแหน่ง (Position) </v-col><v-col class="py-0" cols="6">{{
                            form?.area_form_3?.contact_position
                          }}</v-col></v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          โทรศัพท์ (Telephone No.) </v-col><v-col class="py-0" cols="6">
                          {{ form?.area_form_3?.contact_phone }}
                        </v-col></v-col>
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          มือถือ (Mobile Phone) </v-col><v-col class="py-0" cols="6">{{
                            form?.area_form_3?.contact_mobile_phone
                          }}</v-col></v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6">
                          โทรสาร (Facsimile No.) </v-col><v-col class="py-0" cols="6">
                          {{ form?.area_form_3?.contact_fac }}
                        </v-col></v-col>
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> อีเมล (E-mail) </v-col><v-col
                          class="py-0" cols="6">{{
                            form?.area_form_3?.contact_email
                          }}</v-col></v-col>
                    </v-row>
                    <v-row class="pt-2">
                      <v-col class="py-0 d-flex" cols="6"><v-col class="py-0" cols="6"> ที่อยู่ </v-col><v-col
                          class="py-0" cols="6">
                          {{ form?.area_form_3?.contact_address }}
                        </v-col></v-col>
                    </v-row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </divcard>
      <divcard titled>
        <div class="txt-head black--text mb-2 d-flex align-items-center card-part-orange">
          <span class="theme-color-one">ส่วนที่ 4 : </span>
          เอกสาร
        </div>
        <div>
          <v-layout align-center class="mt-3" v-for="(file, f) in form?.attachments" :key="f">
            <v-flex shrink class="to-hide">
              <v-btn depressed dark rounded width="125" color="#F15A29" @click="downloadFile(file)">
                <Iconify style="color: #fff" icon="system-uicons:download"></Iconify>
                <span class="font-12 font-w-700">ดาวน์โหลด</span>
              </v-btn>
            </v-flex>
            <v-flex shrink ml-3>
              {{ file.file_name }}
            </v-flex>
          </v-layout>
          <!-- <v-layout
            align-center
            class="mt-3"
            v-for="(file, f) in form?.attachments"
            :key="f"
          >
            <TextField :value="file.file_name" readonly disabled></TextField>
          </v-layout> -->
        </div>
      </divcard>
    </div>
    <div v-if="$route.query.preview" class="d-flex justify-space-between to-hide">
      <Button theme="2" @onClick="$router.push({ name: 'spaceRequestsList' })">ยกเลิก</Button>
    </div>
  </div>
</template>

<script>
import Button from "../../components/input/Button";
import TextField from "../../components/input/TextField";
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { apiDomain } from "@/store/constants";
import ValidatorIcon from "../../components/ValidatorIcon";
import * as XLSX from "xlsx";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "RequestPreview",
  components: {
    Button,
    ValidatorIcon,
    TextField,
  },
  data() {
    return {
      form: {},
      form2_5: [],
      tableHeader: [
        {
          name: "ปีที่",
          width: "10%",
        },
        {
          name: "ชื่อโครงการ",
          width: "20%",
        },
        {
          name: "แผนการดำเนินงาน",
          width: "30%",
        },
        {
          name: "งบประมาณ",
          width: "15%",
        },
        {
          name: "ระยะเวลา ดำเนินการ",
          width: "15%",
        },
        {
          name: "แหล่งทุน",
          width: "10%",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.Auth.User,
      user: (state) => state.Auth.User,
    }),
  },
  created() {
    this.retrieveForms();
  },
  methods: {
    backForm(id) {
      this.$router.push({
        path: `/space-requests-management/space-requests-form/${id}`,
      });
    },
    filterIndustries(obj) {
      if (obj === null) return;
      Object.keys(obj).forEach((key) => {
        if (key.startsWith("industry_") && obj[key] === 1) {
          this.form2_5.push({ name: key });
        }
      });
    },
    retrieveForms() {
      // Retrieve the form data
      this.$apiFire("Request/getSpaceRequestsListById", {
        id: this.$route.params.id,
      }).then((res) => {
        console.info("getSpaceRequestsListById: ", res);
        if (res) {
          this.filterIndustries(res?.area_form_2);
          this.form = {
            ...res,
            area_form_2: {
              ...res.area_form_2,
              region: res.region ?? res.area_form_2?.region,
            },
            form2_5: this.form2_5,
          };
          console.log(this.form);
        }
      });
    },

    validate(section) {
      let isCorrect = true;
      switch (section) {
        case "one":
          if (!this.form?.user_type) {
            isCorrect = false;
          }
          return isCorrect;

        // case "two"
        case "two_one":
          if (
            !this.form?.area_form_2?.company_name_th ||
            !this.form?.area_form_2?.company_name_eng ||
            !this.form?.area_form_2?.headquarters_address ||
            !this.form?.area_form_2?.headquarters_postal_code ||
            !this.form?.area_form_2?.headquarters_phone ||
            !this.form?.area_form_2?.headquarters_email ||
            !this.form?.area_form_2?.headquarters_website
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_two":
          if (
            !this.form?.area_form_2?.contact_name ||
            !this.form?.area_form_2?.contact_position ||
            !this.form?.area_form_2?.contact_email ||
            !this.form?.area_form_2?.contact_phone ||
            !this.form?.area_form_2?.contact_address
          ) {
            isCorrect = false;
          }

          return isCorrect;

        case "two_three":
          if (
            !this.form?.area_form_2?.registration_number ||
            !this.form?.area_form_2?.registration_date ||
            !this.form?.area_form_2?.registration_capital ||
            !this.form?.area_form_2?.business_size?.name ||
            this.form?.area_form_2?.area_form_2_3?.length == 0
          ) {
            isCorrect = false;
          }
          if (this.form?.area_form_2?.area_form_2_3?.length > 0) {
            this.form?.area_form_2?.area_form_2_3.forEach((item) => {
              if (
                item.name == null ||
                item.name == "" ||
                item.position === null ||
                item.position == "" ||
                item.mobile_phone === null ||
                item.mobile_phone == "" ||
                item.email === null ||
                item.email == ""
              ) {
                isCorrect = false;
              }
            });
          }

          return isCorrect;
        // case "two_four":
        //   if (
        //     !this.form?.area_form_2?.headquarters_joint_name ||
        //     !this.form?.area_form_2?.headquarters_joint_nationality ||
        //     !this.form?.area_form_2?.headquarters_joint_country ||
        //     !this.form?.area_form_2?.headquarters_joint_capital ||
        //     !this.form?.area_form_2?.headquarters_joint_website
        //   ) {
        //     isCorrect = false;
        //   }

        //   return isCorrect;
        case "two_five":
          if (!this.form?.form2_5 || this.form?.form2_5?.length == 0) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_six":
          if (!this.form?.area_form_2?.reason_choose) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_seven":
          if (!this.form?.area_form_2?.area_type?.name) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_eight":
          if (!this.form?.area_form_2?.region && !this.form?.region) {
            isCorrect = false;
          }
          return isCorrect;
        case "two_nine":
          if (this.form?.area_form_2?.area_form_2_8?.length == 0) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_ten":
          if (
            !this.form?.area_form_2?.space_requirement_type ||
            this.form?.area_form_2?.area_form_2_9?.length == 0
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_eleven":
          if (!this.form?.area_form_2?.product_service_eco) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_twelve":
          if (
            !this.form?.area_form_2?.space_ratio_lab &&
            !this.form?.area_form_2?.space_ratio_office
          ) {
            isCorrect = false;
          }
          if (
            this.form?.area_form_2?.space_ratio_lab &&
            !this.form?.area_form_2?.space_ratio_lab_percent
          ) {
            isCorrect = false;
          }
          if (
            this.form?.area_form_2?.space_ratio_office &&
            !this.form?.area_form_2?.space_ratio_office_percent
          ) {
            isCorrect = false;
          }

          return isCorrect;
        case "two_thirteen":
          if (!this.form?.area_form_2?.type_of_area_usage) {
            isCorrect = false;
          }
          if (
            this.form?.area_form_2?.type_of_area_usage ===
            "จัดตั้งศูนย์วิจัยและพัฒนา (Research & Development Center)"
          ) {
            if (
              !this.form?.area_form_2?.type_of_area_usage_th ||
              !this.form?.area_form_2?.type_of_area_usage_eng
            ) {
              isCorrect = false;
            }
          }
          if (this.form?.area_form_2?.type_of_area_usage === "อื่นๆ") {
            if (!this.form?.area_form_2?.type_of_area_usage_other) {
              isCorrect = false;
            }
          }
          return isCorrect;

        // case "three"
        case "three_one":
          if (this.form?.area_form_3?.spider_chart_3?.length == 0) {
            isCorrect = false;
          }
          return isCorrect;
        case "three_two":
          if (this.form?.area_form_3?.area_form_3_2?.length == 0) {
            isCorrect = false;
          }
          return isCorrect;
        case "three_three":
          if (!this.form?.area_form_3?.estimated_date) {
            isCorrect = false;
          }
          return isCorrect;
        case "three_four":
          if (
            !this.form?.area_form_3?.appendix_info &&
            !this.form?.area_form_3?.appendix_doc_cert &&
            !this.form?.area_form_3?.appendix_doc_id_card_company &&
            !this.form?.area_form_3?.appendix_doc_witness &&
            !this.form?.area_form_3?.appendix_doc_postal &&
            !this.form?.area_form_3?.appendix_doc_contact
          ) {
            isCorrect = false;
          }
          if (this.form?.area_form_3?.appendix_doc_postal) {
            if (
              !this.form?.area_form_3?.postal_name ||
              !this.form?.area_form_3?.postal_position ||
              !this.form?.area_form_3?.postal_mobile_phone ||
              !this.form?.area_form_3?.postal_email ||
              !this.form?.area_form_3?.postal_address
            ) {
              isCorrect = false;
            }
          }
          if (this.form?.area_form_3?.appendix_doc_contact) {
            if (
              !this.form?.area_form_3?.contact_name ||
              !this.form?.area_form_3?.contact_position ||
              !this.form?.area_form_3?.contact_mobile_phone ||
              !this.form?.area_form_3?.contact_email ||
              !this.form?.area_form_3?.contact_address
            ) {
              isCorrect = false;
            }
          }
          return isCorrect;
        default:
          return isCorrect;
      }
    },

    onExport() {
      alert("export");
    },

    print() {
      //get current date dd-mm-yyyy
      let today = new Date();
      let dd = today.getDate();
      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = dd + "-" + mm + "-" + yyyy;

      //change document title
      document.title =
        "space_requests_preview_" + this.userInfo.user_type + "_" + today;
      let toHide = document.getElementsByClassName("to-hide");
      let pdfPage = document.getElementById("pdf");
      let mainContent = document.getElementById("main");
      let titled = document.getElementsByClassName("titled");
      let toShow = document.getElementsByClassName("to-show");
      let noBoxShadow = document.getElementsByClassName("no-box-shadow");
      let s3p1 = document.getElementsByClassName("s3-p1");
      let s3p1h = document.getElementsByClassName("s3-p1-h");
      let indent_info = document.getElementsByClassName("indent-info");

      //remove all class name indent-info
      for (let i = 0; i < indent_info.length; i++) {
        indent_info[i].style.paddingLeft = "10px";
      }

      //show toShow
      for (let i = 0; i < toShow.length; i++) {
        toShow[i].style.display = "block";
        toShow[i].style.visibility = "visible";
        toShow[i].style.height = "auto";
      }

      //hide toHide
      for (let i = 0; i < toHide.length; i++) {
        toHide[i].style.display = "none";
        toHide[i].style.visibility = "hidden";
      }
      for (let i = 0; i < titled.length; i++) {
        titled[i].style.boxShadow = "none";

        //set box shadow to every child of titled
        let titledChild = titled[i].children;
        for (let j = 0; j < titledChild.length; j++) {
          titledChild[j].style.boxShadow = "none";
        }
      }

      //set no-box-shadow box-shadow to none
      for (let i = 0; i < noBoxShadow.length; i++) {
        noBoxShadow[i].style.boxShadow = "none";

        //set border
        noBoxShadow[i].style.border = "1px solid #F5F5F5";
      }

      //set s3p1 style scale 0.8
      for (let i = 0; i < s3p1.length; i++) {
        s3p1[i].style.transform = "scale(0.75)";
        s3p1[i].style.transformOrigin = "top left";
        s3p1[i].style.alignItems = "flex-start";

        //remove class overflow-x-auto
        s3p1[i].classList.remove("overflow-x-auto");
      }
      //set s3p1h style height
      for (let i = 0; i < s3p1h.length; i++) {
        s3p1h[i].style.height = "auto";
      }

      // pdfPage.style.minWidth = '600px'
      pdfPage.style.width = "750px";
      mainContent.style.paddingLeft = 0;
      mainContent.style.backgroundColor = "#fff";

      window.print();

      //reload
      window.location.reload();
    },

    downloadFile(file) {
      axios({
        url: `/api/download/${file.id}`,
        method: "GET",
        responseType: "blob",
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", file.file_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          this.$store.commit("General/setModal", {
            title: "ระบบไม่พบไฟล์ที่ร้องขอ",
            theme: "warning",
            text: "กรุณาติดต่อเจ้าหน้าที่",
            showCancel: false,
            buttonText: "ตกลง",
          });
        });
    },

    changeToFullName(value) {
      switch (value) {
        case "industry_food":
          return "Food and Agriculture";
        case "industry_ict":
          return "ICT and Software";
        case "industry_science":
          return "Science as a Service";
        case "industry_materials":
          return "Materials Science and Chemicals";
        case "industry_electronics":
          return "Electronics, Robotics and Automation";
        case "industry_medical":
          return "Medical Device and Pharmaceutical";
        case "industry_auto":
          return "Auto Parts";
        case "industry_others":
          return "Other";
        default:
          return "-";
      }
    },
  },
};
</script>

<style scoped>
@page {
  size: A4 portrait;
  margin: 1mm 1mm 1mm 1mm;
}
</style>
